<form #spendEntry="ngForm" role="form" class="mb-6">
  <app-commitment-entry-text
    (removeClicked)="removeEntry()"
    entryType="General"
    [index]="index"
    [text]="'Spend Entry'"
    [disableRemoveEntry]="model?.has_commitments || disableRemoveEntry"
    [showRemoveIcon]="true"
  ></app-commitment-entry-text>

  <div class="horizontal-spacing">
    <div [ngClass]="{ 'two-input-row': user.isManager }">
      <app-floating-input
        [required]="true"
        [readonly]="true"
        [disabled]="model?.has_commitments === true"
        (click)="!model?.has_commitments && onLineItemInputClick($event)"
        name="item_name"
        placeholder="Budget Line Item"
        label="Budget Line Item"
        #item_name="ngModel"
        #budgetLineOptionsTrigger="cdkOverlayOrigin"
        cdkOverlayOrigin
        [(ngModel)]="model.item!.name"
        class="flex-1 cursor-pointer"
        inputClass="cursor-pointer"
        [iconClass]="isDropdownShown.line_item ? 'dropdown-icon opened' : 'dropdown-icon closed'"
      >
        <ng-container floatingInputDisplayValue>
          <div class="flex w-full h-full justify-center flex-col">
            <app-faded-text>
              <div class="whitespace-nowrap font-semibold pb-0.5">{{ model.item?.name }}</div>
              @if (model.item?.division || model.item?.cost_type) {
                <div class="whitespace-nowrap text-size_m font-normal">
                  {{ model.item?.division }}{{ model.item?.division && model.item?.cost_type ? '.' : ''
                  }}{{ model.item?.cost_type }}
                </div>
              }
            </app-faded-text>
          </div>
        </ng-container>
      </app-floating-input>
      <app-overlay-general
        [(show)]="isDropdownShown.line_item"
        [trigger]="budgetLineOptionsTrigger"
        [overlayPositions]="dropdownAlignRight"
      >
        <app-budget-line-item-view-table-dropdown
          [disabledLineItems]="disabledLineItems"
          (optionSelected)="lineItemOptionSelected($event)"
          [commitmentType]="commitmentType"
        >
        </app-budget-line-item-view-table-dropdown>
      </app-overlay-general>

      @if (user.isManager) {
        <app-floating-input
          #optionsTrigger="cdkOverlayOrigin"
          cdkOverlayOrigin
          readonly
          [disabled]="model?.has_commitments || disableBudgetTagDropdown"
          (click)="!(model?.has_commitments || disableBudgetTagDropdown) && (isDropdownShown.budget_tag = true)"
          id="budget_tag"
          name="budget_tag"
          [(ngModel)]="model.budget_tag.name"
          placeholder="Budget Tag"
          label="Budget Tag"
          class="cursor-pointer"
          inputClass="cursor-pointer"
          [iconClass]="isDropdownShown.budget_tag ? 'dropdown-icon opened' : 'dropdown-icon closed'"
        ></app-floating-input>
        <app-overlay-general
          [(show)]="isDropdownShown.budget_tag"
          [trigger]="optionsTrigger"
          [overlayPositions]="dropdownAlignRight"
        >
          <!--          @if (isDropdownShown.budget_tag) {-->
          <app-budget-tag-templates-dropdown
            [budgetTemplateTags]="budgetTags$ | async"
            [disabledBudgetTagIds]="disabledBudgetTagIds"
            [hasTemplate]="!!model.budget_tag.id"
            (optionSelected)="selectedBudgetTag($event)"
            (unlinkTemplate)="unlinkTemplate()"
          ></app-budget-tag-templates-dropdown>
          <!--          }-->
        </app-overlay-general>
      }
    </div>

    @if (commitmentType !== COMMITMENTS_INTERACTION_BAR_TYPE.DIRECT_COST) {
      <div [ngClass]="{ 'p-disabled': model?.has_commitments }" class="two-input-row">
        @if (
          commitmentType === COMMITMENTS_INTERACTION_BAR_TYPE.ADD_CONTRACT ||
          commitmentType === COMMITMENTS_INTERACTION_BAR_TYPE.PC_TO_CONTRACT
        ) {
          <span class="flex-1 min-w-0">
            <app-input-calendar
              #calendar_picker
              [required]="true"
              [date]="model.start_date"
              [minStartDate]="commitmentAddedAt ?? projectData?.start_date"
              [showIcon]="true"
              (dateChanged)="updateEntryDate($event)"
              placeholder="Start Date"
            ></app-input-calendar>
          </span>
        }
        @if (changeOrderType !== CHANGE_ORDER_TYPE.DOLLARS) {
          <app-dropdown
            [required]="true"
            name="duration"
            [(ngModel)]="model.duration"
            [options]="spendDurationMonths"
            optionLabel="label"
            optionValue="value"
            [placeholder]="
              changeOrderType === CHANGE_ORDER_TYPE.SCOPE ||
              commitmentType !== COMMITMENTS_INTERACTION_BAR_TYPE.CHANGE_ORDER
                ? 'Duration'
                : 'Duration Extension'
            "
            [label]="
              changeOrderType === CHANGE_ORDER_TYPE.SCOPE ||
              commitmentType !== COMMITMENTS_INTERACTION_BAR_TYPE.CHANGE_ORDER
                ? 'Duration'
                : 'Duration Extension'
            "
            (ngModelChange)="updateCommitmentItem()"
            [ngClass]="{
              'col-span-2': commitmentType === COMMITMENTS_INTERACTION_BAR_TYPE.CHANGE_ORDER,
            }"
          >
            <ng-template let-duration #selectedContent>
              {{ duration.label }} {{ duration.label === 1 ? 'Month' : 'Months' }}
            </ng-template>
            <ng-template let-duration #optionContent>
              {{ duration.label }} {{ duration.label === 1 ? 'Month' : 'Months' }}
            </ng-template>
          </app-dropdown>
        }
      </div>
    }

    @for (cost of model.costs; let costIndex = $index; track trackByIndexCombination(costIndex, index)) {
      <app-cost-description
        #costDescription
        [commitmentType]="commitmentType"
        [spendEntryIndex]="index"
        [costIndex]="costIndex"
        [model]="cost"
        [totalCostCount]="model.costs.length"
        [changeOrderType]="changeOrderType"
        [disabledOptionIds]="disabledSpendOptions()"
        [disableAddDescription]="disableAddDescription"
        [disabledAddDescriptionTooltip]="disabledAddDescriptionTooltip"
      ></app-cost-description>
    }
  </div>
</form>
